import { StateCreator } from 'zustand'

const isAddVehicleIdDialogVisibleInitialState = false

export interface IsAddVehicleIdDialogVisibleSlice {
  isAddVehicleIdDialogVisible: boolean
  setIsAddVehicleIdDialogVisible: (payload: boolean) => void
}

const createIsAddVehicleIdDialogVisibleSlice: StateCreator<
  IsAddVehicleIdDialogVisibleSlice
> = (set) => ({
  isAddVehicleIdDialogVisible: isAddVehicleIdDialogVisibleInitialState,
  setIsAddVehicleIdDialogVisible: (payload) => {
    set(() => ({
      isAddVehicleIdDialogVisible: payload,
    }))
  },
})

export default createIsAddVehicleIdDialogVisibleSlice
